export default __webpack_public_path__ + "static/media/BumpBoxes_Web_Registry_Webslider_Mobile.113e8e22.png";